<template>
  <footer class="bg-dark text-center text-white">
    <div class="container p-4 pb-0">
      <div class="row justify-content-center">
        <div class="col-md-auto mb-4">
          <a href="/" class="text-white text-uppercase">Home</a>
        </div>
        <div class="col-md-auto mb-4">
          <a href="/Wisata" class="text-white text-uppercase">Explore</a>
        </div>
        <div class="col-md-auto mb-4">
          <a href="/Planner" class="text-white text-uppercase">Planner</a>
        </div>
        <div class="col-md-auto mb-4">
          <a href="/Aboutus" class="text-white text-uppercase">About Us</a>
        </div>
        <div class="col-md-auto mb-4">
          <a href="/Help" class="text-white text-uppercase">Help</a>
        </div>
      </div>
      <section class="mb-4">
        <a
          class="btn btn-outline-light btn-floating m-1"
          href="#!"
          role="button"
          ><i class="fab fa-facebook-f"></i
        ></a>
        <a
          class="btn btn-outline-light btn-floating m-1"
          href="#!"
          role="button"
          ><i class="fab fa-twitter"></i
        ></a>
        <a
          class="btn btn-outline-light btn-floating m-1"
          href="#!"
          role="button"
          ><i class="fab fa-instagram"></i
        ></a>
      </section>
    </div>
    <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0)">
      © 2021 Copyright:
      <a class="text-white" href="#">MyTour 2021</a>
    </div>
  </footer>
</template>
<style>
* {
  font-family: "Montserrat", sans-serif;
}
</style>